import React from "react";
import PropTypes from "prop-types";
import Section from "../common/Section";
import Form from "../common/Form";
import * as domainConstants from '../../constants/DomainConstants';
import * as types from "../../constants/ComponentConstants";
import Row from "../common/Row";
import RadioButtonGroup from "../common/RadioButtonGroup";
import TextInput from "../common/TextInput";
import SelectInput from "../common/SelectInput";
import Dropdown from "../common/Dropdown";
import Button from "../common/Button";
import Marker from "../common/Marker";
import Fieldset from "../common/Fieldset";
import Tooltip from "../common/Tooltip";
import Map from "../common/map/Map";
import Markers from "../common/map/Markers";

const InfrastructuurDetailForm = (props) => {
    const {
        model,
        color,
        isNew,
        isSpakki,
        onChange,
        soortenWerken,
        soortenInfrastructuur,
        gemeenten,
        postcodes,
        mapKey,
        mapEditMode,
        mapNewCoords,
        onSave,
        onCancel,
        onReplacePoint,
        onSaveNewPoint,
        onCancelReplace,
        onGetGeoCoordinates,
        errors,
        databeheerderTelefoon,
        databeheerderEmail,
        maxMapFeaturesToLoad,
        osmBaseLayerUrl,
        onMarkerDragEnd,
        validationMessageType
    } = props;

    const formTitle = isNew ? "Voeg ontbrekende sportinfrastructuren toe aan mijn project" : "Wijzig sportinfrastructuur " + model.naam;
    const selectedSoortInfrastructuur = soortenInfrastructuur.find(x => x.id === model.soortInfrastructuurId);
    const sporttakken = selectedSoortInfrastructuur ? selectedSoortInfrastructuur.sporttakken.map((sporttak) => {
        return {
            value: sporttak.id,
            text: sporttak.id,
            label: sporttak.naam
        };
    })
        : null;
    const soortenInfrastructuurList = soortenInfrastructuur.map((soortInfrastructuurObject) => {
        return {
            value: soortInfrastructuurObject.id,
            label: soortInfrastructuurObject.description,
            text: soortInfrastructuurObject.description
        };
    });

    const createMapOptions = (maps) => {
        return ({
            panControl: true,
            scrollwheel: false,
            fullscreenControl: false,
            mapTypeControl: true,
            minZoom: 14
        });
    };
    const mijnInfrastructuur = (<Marker
        lat={parseFloat(mapNewCoords.lat)}
        lng={parseFloat(mapNewCoords.lng)}
        color="orange"
    />);
    const wijzigMapTooltip = "Het is zeer belangrijk dat de aangevraagde infrastructuur aangeduid is exact op de plaats waar deze zal gerealiseerd worden. Dit is het midden van de sportinfrastructuur.";
    const soortenWerkenFiltered = isSpakki ? soortenWerken.filter(s => s.value == model.soortWerken) : soortenWerken;

    const markersToShow = [{
        lat: parseFloat(mapNewCoords.lat),
        long: parseFloat(mapNewCoords.lng),
        size: 'x-large',
        color: types.COLOR_ORANGE,
        draggable: mapEditMode,
        onDragEnd: onMarkerDragEnd
    }];

    const mijnProjectMarker = <Markers markersToShow={markersToShow} />;
    const customBounds = markersToShow.map(m => [m.lat, m.long]);

    return (<Section title={"Vul het antwoord op onderstaande vragen in"} color={color}>
        <Form
            title={formTitle}
            name={"InfrastructuurDetail"}
            leftButtonLabel={"Annuleer"}
            onLeftButtonClick={onCancel}
            leftButtonDisabled={mapEditMode}
            rightButtonLabel={"Bewaar"}
            onRightButtonClick={onSave}
            rightButtonDisabled={mapEditMode}>
            <Fieldset>
                {isSpakki ?
                    <p style={{ fontSize: '14px', fontWeight: 'bold', marginLeft: '.83333%', marginBottom: '.83333%' }}>
                        Correcties aan de bestaande gegevens van deze sportinfrastructuur die niet het gevolg zijn van de geplande renovatiewerken moeten telefonisch of via E-mail gemeld worden aan de databeheerder van de sportdatabank van Sport Vlaanderen.<br /><i className="fa fa-phone fa-fw" />{databeheerderTelefoon} <i className="fa fa-envelope fa-fw" />{databeheerderEmail}.
            </p> :
                    null
                }
                <Row>
                    <RadioButtonGroup
                        name={"soortWerken"}
                        label={"Soort werken"}
                        onChange={onChange}
                        items={soortenWerkenFiltered}
                        value={model.soortWerken}
                        size={12}
                        validationMessage={errors ? errors.soortWerken : ''}
                        validationMessageType={validationMessageType}
                        horizontal
                        labelInside
                        disabled
                    />
                </Row>
                <Row>
                    <TextInput
                        name={"naam"}
                        label={"Naam"}
                        value={model.naam}
                        onChange={onChange}
                        maxLength={300}
                        validationMessage={errors ? errors.naam : ''}
                        validationMessageType={validationMessageType}
                        size={12}
                    />
                </Row>
                <Row>
                    <SelectInput
                        name={"soortInfrastructuurId"}
                        label={"Soort infrastructuur"}
                        onChange={onChange}
                        value={model.soortInfrastructuurId}
                        validationMessage={errors ? errors.soortInfrastructuurId : ''}
                        validationMessageType={validationMessageType}
                        size={model.soortInfrastructuurId != domainConstants.ANDERE_INFRASTRUCTUUR_GUID ? 12 : 6}
                        items={soortenInfrastructuurList}
                    />
                    {model.soortInfrastructuurId != domainConstants.ANDERE_INFRASTRUCTUUR_GUID ||
                        <TextInput
                            name={"andereInfrastructuur"}
                            label={"Andere infrastructuur"}
                            value={model.andereInfrastructuur}
                            onChange={onChange}
                            maxLength={200}
                            validationMessage={errors ? errors.andereInfrastructuur : ''}
                            validationMessageType={validationMessageType}
                            size={6}
                        />
                    }
                </Row>
                {sporttakken && sporttakken.length > 1 ?
                    < Row >
                        <div className="o-col-6" style={{ paddingTop: "1em", paddingLeft: "1em" }}> Welke sporttak zal er hoofdzakelijk beoefend worden?</div>
                        <SelectInput
                            name={"sporttak"}
                            label={"Sporttak"}
                            onChange={onChange}
                            value={model.sporttak}
                            size={6}
                            items={sporttakken}
                            validationMessage={errors ? errors.sporttak : ''}
                            validationMessageType={validationMessageType}
                        />
                    </Row> : null}
                {model.soortWerken && model.soortWerken.toString() === domainConstants.INFRASTRUCTUUR_TYPE.RENOVATIE.toString() ?
                    <Row>
                        <TextInput
                            name={"bouwjaar"}
                            label={"Oorspronkelijk bouwjaar"}
                            value={model.bouwjaar}
                            onChange={onChange}
                            maxLength={4}
                            validationMessage={errors ? errors.bouwjaar : ''}
                            validationMessageType={validationMessageType}
                            size={6}
                            disabled={isSpakki}
                        />
                        <TextInput
                            name={"renovatiejaar"}
                            label={"Jaar laatste grondige renovatie"}
                            value={model.renovatiejaar}
                            onChange={onChange}
                            maxLength={4}
                            validationMessage={errors ? errors.renovatiejaar : ''}
                            validationMessageType={validationMessageType}
                            size={6}
                            optional
                            disabled={isSpakki}
                        />
                    </Row>
                    : null}
                <Row>
                    <TextInput
                        name={"straatHuisnummer"}
                        label={"Straat en huisnummer"}
                        value={model.straatHuisnummer}
                        onChange={onChange}
                        maxLength={500}
                        validationMessage={errors ? errors.straatHuisnummer : ''}
                        validationMessageType={validationMessageType}
                        size={12}
                        disabled={isSpakki}
                    />
                </Row>
                <Row>
                    <Dropdown
                        name={"postcode"}
                        label={"Postcode"}
                        value={model.postcode}
                        onChange={onChange}
                        validationMessage={errors ? errors.postcode : ''}
                        validationMessageType={validationMessageType}
                        size={4}
                        items={postcodes}
                        noResultsMessage="Tik (2 cijfers) en zoek"
                        disabled={isSpakki}
                    />
                    <Dropdown
                        name={"gemeente"}
                        label={"Gemeente"}
                        onChange={onChange}
                        value={model.gemeente}
                        size={8}
                        items={gemeenten}
                        validationMessage={errors ? errors.gemeente : ''}
                        validationMessageType={validationMessageType}
                        disabled={isSpakki}
                    />
                </Row>
                <Row>
                    <Button
                        onClick={onGetGeoCoordinates}
                        text={"Positioneer infrastructuur op de kaart"}
                        className={"o-col-4"}
                        disabled={isSpakki}
                        style={{ marginLeft: '0.8333%', marginRight: '0.8333%' }}
                    />
                    <TextInput
                        name={"breedtegraad"}
                        label={"Breedtegraad"}
                        onChange={onChange}
                        value={model.breedtegraad}
                        validationMessage={errors ? errors.breedtegraad : ''}
                        validationMessageType={validationMessageType}
                        size={4}
                        disabled
                    />
                    <TextInput
                        name={"lengtegraad"}
                        label={"Lengtegraad"}
                        onChange={onChange}
                        value={model.lengtegraad}
                        validationMessage={errors ? errors.lengtegraad : ''}
                        validationMessageType={validationMessageType}
                        size={4}
                        disabled
                    />
                </Row>
                <Row>
                    <Map
                        mapName={mapKey}
                        maxMapFeaturesToLoad={maxMapFeaturesToLoad}
                        baseLayerUrl={osmBaseLayerUrl}
                        baseLayerAttribution='&copy; <a href="https://openstreetmap.org">OpenStreetMap</a> contributors, Tiles courtesy of <a href="https://geo6.be/">GEO-6</a>'
                        children={mijnProjectMarker}
                        zoom={12}
                        showEmptyMap
                        hideLegende
                        onlyBaseLayers
                        customBounds={customBounds}
                    />
                </Row>
                <Row>
                    <br />
                    {mapEditMode === false ?
                        <span>
                            <Button
                                onClick={onReplacePoint}
                                text={'Wijzig de ligging op de kaart'}
                            />
                            <Tooltip
                                text={wijzigMapTooltip}
                                iconColor={types.COLOR_BLUE_DARK}
                                tooltipType={types.TOOLTIP_INFO}
                                windowWidth={35}
                                windowAlignRight={false} />
                        </span>
                        : ''}
                    {mapEditMode === true ?
                        <span>
                            <Button
                                onClick={onSaveNewPoint}
                                text={'Bewaar locatie'}
                            />
                            <Button
                                onClick={onCancelReplace}
                                text={'Annuleer'}
                            />
                        </span>
                        : ''}
                </Row>
            </Fieldset>
        </Form>
    </Section >);
};

InfrastructuurDetailForm.propTypes = {
    color: PropTypes.string.isRequired,
    model: PropTypes.object.isRequired,
    isNew: PropTypes.bool,
    isSpakki: PropTypes.bool,
    mapKey: PropTypes.string.isRequired,
    mapEditMode: PropTypes.bool.isRequired,
    mapNewCoords: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    onReplacePoint: PropTypes.func.isRequired,
    onSaveNewPoint: PropTypes.func.isRequired,
    onCancelReplace: PropTypes.func.isRequired,
    onGetGeoCoordinates: PropTypes.func.isRequired,
    soortenWerken: PropTypes.array.isRequired,
    soortenInfrastructuur: PropTypes.array.isRequired,
    gemeenten: PropTypes.array.isRequired,
    postcodes: PropTypes.array.isRequired,
    errors: PropTypes.array.isRequired,
    databeheerderEmail: PropTypes.string,
    databeheerderTelefoon: PropTypes.string,
    maxMapFeaturesToLoad: PropTypes.string,
    osmBaseLayerUrl: PropTypes.string,
    onMarkerDragEnd: PropTypes.func,
    validationMessageType: PropTypes.string
};

export default InfrastructuurDetailForm;